export default __webpack_public_path__ + "static/media/NU.62d2f1f7.svg";